import Section from '../Section';

export default class Newsletter extends Section {

}
